module.exports = __webpack_public_path__ + "static/media/10-iveco.e54778ed.jpg";